export default __webpack_public_path__ + "static/media/icon5.900ae892.svg";